import { Badge } from '@/components/ui/badge';
import type { AdminUser } from '@/types/admin.model';

// The `outline` badge variant sets `hover:text-white` for clickable badges, which
// would wash out these read-only badges on hover (e.g. white text on bg-blue-100).
// Each style pins its own text color back on hover to override that.
const ROLE_STYLES: Record<string, string> = {
  USER: 'border-gray-200 bg-gray-100 text-gray-700 hover:text-gray-700',
  MANAGER: 'border-blue-200 bg-blue-100 text-blue-700 hover:text-blue-700',
  OWNER: 'border-green-200 bg-green-100 text-green-700 hover:text-green-700',
  INSTRUCTOR: 'border-violet-200 bg-violet-100 text-violet-700 hover:text-violet-700',
  ADMIN: 'border-red-200 bg-red-100 text-red-700 hover:text-red-700',
  FUTURE_OWNER: 'border-gray-200 bg-gray-100 text-gray-500 hover:text-gray-500',
  PENDING_DEBT: 'border-amber-200 bg-amber-100 text-amber-700 hover:text-amber-700',
};

export const RoleBadge = ({ role }: { role: string }) => (
  <Badge
    variant="outline"
    className={
      ROLE_STYLES[role] ?? 'border-gray-200 bg-gray-100 text-gray-700 hover:text-gray-700'
    }
  >
    {role}
  </Badge>
);

export const StatusBadge = ({ user }: { user: AdminUser }) => {
  if (user.deleted) {
    return (
      <Badge
        variant="outline"
        className="border-red-200 bg-red-100 text-red-700 hover:text-red-700"
      >
        Eliminado
      </Badge>
    );
  }
  if (user.banned) {
    return (
      <Badge
        variant="outline"
        className="border-orange-200 bg-orange-100 text-orange-700 hover:text-orange-700"
      >
        Baneado
      </Badge>
    );
  }
  return (
    <Badge
      variant="outline"
      className="border-green-200 bg-green-100 text-green-700 hover:text-green-700"
    >
      Activo
    </Badge>
  );
};
